<ng-template let-item="item">
    {{item.name}}
</ng-template>
